import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiDownload, FiSend, FiCheck } from 'react-icons/fi';
import { invoiceAPI, pdfAPI } from '../../services/api';

const InvoiceDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchInvoice = () => invoiceAPI.getById(id).then(r => { setInvoice(r.data); setLoading(false); }).catch(() => navigate('/invoices'));
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchInvoice(); }, [id]);

  const downloadPDF = async () => {
    const { data } = await pdfAPI.downloadInvoice(id);
    const url = window.URL.createObjectURL(new Blob([data]));
    const a = document.createElement('a'); a.href = url; a.download = `facture-${invoice.invoice_number}.pdf`; a.click();
  };

  const handleSend = async () => { await invoiceAPI.send(id); fetchInvoice(); };
  const handleMarkPaid = async () => { await invoiceAPI.markPaid(id); fetchInvoice(); };

  if (loading) return <div className="loading"><div className="spinner" /></div>;
  if (!invoice) return null;

  const clientName = invoice.tenant_first_name ? `${invoice.tenant_first_name} ${invoice.tenant_last_name}` : invoice.client_first_name ? `${invoice.client_first_name} ${invoice.client_last_name}` : '-';

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate('/invoices')}><FiArrowLeft /></button>
          <h1>Facture {invoice.invoice_number}</h1>
          <span className={`badge badge-${invoice.status === 'paid' ? 'success' : invoice.status === 'sent' ? 'info' : 'secondary'}`}>{invoice.status}</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {invoice.status === 'draft' && <button className="btn btn-info btn-sm" onClick={handleSend}><FiSend /> Envoyer</button>}
          {invoice.status !== 'paid' && <button className="btn btn-success btn-sm" onClick={handleMarkPaid}><FiCheck /> Marquer payée</button>}
          <button className="btn btn-secondary btn-sm" onClick={downloadPDF}><FiDownload /> PDF</button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
            <div>
              <h2 style={{ fontSize: 20 }}>{invoice.agency_name}</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: 13 }}>{invoice.agency_address}<br/>{invoice.agency_phone} | {invoice.agency_email}</p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <h3>Client</h3>
              <p>{clientName}<br/>{invoice.tenant_email || invoice.client_email || ''}</p>
            </div>
          </div>

          <div className="grid-3" style={{ marginBottom: 24 }}>
            <div><strong>Date d'émission</strong><br/>{new Date(invoice.issue_date).toLocaleDateString('fr-FR')}</div>
            <div><strong>Date d'échéance</strong><br/>{new Date(invoice.due_date).toLocaleDateString('fr-FR')}</div>
            <div><strong>Type</strong><br/>{invoice.type}</div>
          </div>

          <table>
            <thead><tr><th>Description</th><th style={{ textAlign: 'right' }}>Qté</th><th style={{ textAlign: 'right' }}>P.U.</th><th style={{ textAlign: 'right' }}>Total</th></tr></thead>
            <tbody>
              {invoice.items?.map(item => (
                <tr key={item.id}>
                  <td>{item.description}</td>
                  <td style={{ textAlign: 'right' }}>{item.quantity}</td>
                  <td style={{ textAlign: 'right' }}>{parseInt(item.unit_price).toLocaleString()} XOF</td>
                  <td style={{ textAlign: 'right' }}>{parseInt(item.total).toLocaleString()} XOF</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ width: 250 }}>
              <div className="detail-row"><div className="detail-label">Sous-total</div><div className="detail-value">{parseInt(invoice.subtotal).toLocaleString()} XOF</div></div>
              {parseFloat(invoice.tax_amount) > 0 && <div className="detail-row"><div className="detail-label">TVA ({invoice.tax_rate}%)</div><div className="detail-value">{parseInt(invoice.tax_amount).toLocaleString()} XOF</div></div>}
              <div className="detail-row" style={{ fontWeight: 700, fontSize: 18 }}><div className="detail-label">Total</div><div className="detail-value">{parseInt(invoice.total).toLocaleString()} XOF</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetailPage;
